import React from 'react';
import BulmaContent from 'react-bulma-components/lib/components/content';

import './style.scss';

export const Content = ({ children, size, ...props }) => (
  <BulmaContent size={size} {...props}>
    {children}
  </BulmaContent>
);

export default Content;
